import { clsxm } from '@app/styles/clsxm';
import { SelectQRCodeType } from '../../type/SelectQRCodeType';
import { getTranslationKeyForType } from '../../type/SelectQRCodeTypeContainer';
import { useTranslation } from 'react-i18next';
import { QRCodeTypeItemType } from '@app/domain/qr-code/qr-code.types';
import { ECodeType } from '@app/swagger-types';

export const QRCodeTypeSelector: React.FC<{
  itemType: QRCodeTypeItemType;
  hideOnMobile?: boolean;
  showExpandArrow?: boolean;
  selectBulkType: ECodeType;
  setSelectBulkType: (type: ECodeType) => void;
  forWidgetMode?: boolean;
}> = ({ itemType, hideOnMobile, selectBulkType, setSelectBulkType, forWidgetMode }) => {
  const { t } = useTranslation();

  const { value, icon } = itemType;
  const { titleKey, subTitleKey } = getTranslationKeyForType(value);
  if (!titleKey || !subTitleKey) {
    return null;
  }
  return (
    <SelectQRCodeType
      key={value}
      value={value}
      data-testid={`select-qr-code-type-${value.toLowerCase()}`}
      className={clsxm(hideOnMobile && 'hidden sm:block')}
      forWidgetMode={forWidgetMode}
      title={t(titleKey)}
      subTitle={t(subTitleKey)}
      isActive={selectBulkType === value}
      icon={icon}
      onClick={(v) => {
        setSelectBulkType(v);
      }}
    />
  );
};
